import React from "react";
import { IconsProps } from "./dto";

export function OtherIcon(props: IconsProps) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5002 6.66667V17.5H2.50016V6.66667M8.3335 10H11.6668M0.833496 2.5H19.1668V6.66667H0.833496V2.5Z" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}